import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAutoMappingPost } from 'actions/auto-mapping';
import { ACTIONS as notificationActions } from 'actions/notification';
import { mappingResultImportMapper } from './helpers';

const useLogic = () => {
  const [prospectId, setProspectId] = useState('');
  const [requestedTimeslots, setRequestedTimeslots] = useState([]);
  const [searchResult, setSearchResult] = useState(null);
  const dispatch = useDispatch();

  const onMappingSearchComplete = (errorMessage, data) => {
    if (errorMessage) {
      dispatch({
        type: notificationActions.SHOW_NOTIFICATION,
        payload: {
          text: 'Something went wrong.',
          duration: 10,
          showCloseIcon: true,
        },
      });
    } else {
      setSearchResult(mappingResultImportMapper(data ?? {}));
    }
  };

  const { post: autoMappingSearchPost, isProcessing } = useAutoMappingPost({
    onComplete: onMappingSearchComplete,
  });

  const handleSubmit = useCallback(
    ({ requestedTimes, prospectId, filters }) => {
      setProspectId(prospectId);

      setRequestedTimeslots(requestedTimes);
      const data = {
        action: 'SEARCH',
        prospect_id: prospectId,
        filter: Object.keys(filters)?.map(key => ({
          filter_label: key,
          filter_value: filters[key],
        })),
        requested_times: requestedTimes,
      };
      autoMappingSearchPost(data);
    },
    [autoMappingSearchPost],
  );

  return {
    prospectId,
    handleSubmit,
    mappingSearchResult: searchResult,
    requestedTimeslots,
    submitLoader: isProcessing,
    searchResult,
  };
};

export default useLogic;
